import styled from 'styled-components'

export const LabelComp = styled.div<{ color: string }>`
  margin: 0px auto;
  border: ${({ color }) => `1px solid ${color}`} !important;
  padding: 2px 10px;
  border-radius: 15px;
  position: relative;

  p {
    margin: 0px;

    color: ${({ color }) => color} !important;

    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.24px;
  }

  &::before {
    width: 100%;
    height: 100%;

    left: 0;
    top: 0;

    background: ${({ color }) => `${color}`};
    border-radius: 15px;

    position: absolute;
    opacity: 0.2;
    content: ' ';
  }
`

const Label = (props: any) => {
  const { color } = props
  const colors: any = {
    R: '#E96863',
    A: '#FFC107',
    GL: '#7BDCB5',
    G: '#3BAAB0',
    GREY: 'lightgrey',
  }
  const names: any = {
    R: 'Attention',
    A: 'Moderate Risk',
    GL: 'Suboptimal',
    G: 'Optimal',
    GREY: 'Unknown',
  }
  return (
    <LabelComp color={colors[color]}>
      <p>{names[color] || ''}</p>
    </LabelComp>
  )
}

export default Label
